import React from 'react';
import { InputItem } from 'antd-mobile';
import WrapComponent from './WrapComponent';

class Url extends React.Component{
    render(){
        let {form, api_name, is_readonly, errorText, default_value, is_required, label} = this.props;
        const {getFieldProps}  = form;
        
        let tempProps = {
            type: 'url',
            name: api_name,
            disabled: is_readonly,
            placeholder: $st('请输入')
        }
        
        let fieldProps = getFieldProps(api_name, {
            initialValue: default_value,
            validate: [{
                trigger: 'onChange',
                rules: [{
                    required: is_required,
                    message: $st(`paas.smart.form.isrequired`)
                }]
            },{
                trigger: 'onChange',
                rules: [{
                    pattern: '^(((http[s]?|ftp):\\/\\/|www\\.)[a-z0-9\\.\\-]+\\.([a-z]{2,4})|((http[s]?|ftp):\\/\\/)?(([01]?[\\d]{1,2})|(2[0-4][\\d])|(25[0-5]))(\\.(([01]?[\\d]{1,2})|(2[0-4][\\d])|(25[0-5]))){3})(:\\d+)?(\\/[a-z0-9\\$\\^\\*\\+\\?\\(\\)\\{\\}\\.\\-_~!@#%&:;\\/=<>]*)?',
                    message: `${label}格式不正确`
                }]
            }]
        })
        
        return (
            <InputItem {...tempProps} {...fieldProps} >
                {errorText && <div className='input-error'>{errorText}</div>}
            </InputItem>
        )
    }
}
export default WrapComponent(Url);


// WEBPACK FOOTER //
// ./src/component/Url.js